import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cqs47snpii: FaireBrandEntity = {
  token: "b_cqs47snpii",
  type: "brand",
  name: "Happy Everything!",
  avatarUrl:
    "https://cdn.faire.com/fastly/1d621257a9b4b337654498f89e9874ef97c8e267c8cb4d59d3ea205c2c16dbb5.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/43332a128066f68dc57826a4b2df643ae02899abc059a2bbaaed40d8b4d953fc.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1d621257a9b4b337654498f89e9874ef97c8e267c8cb4d59d3ea205c2c16dbb5.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/43332a128066f68dc57826a4b2df643ae02899abc059a2bbaaed40d8b4d953fc.jpeg",
  location: "Tallahassee, FL, USA",
  minimumOrderDollars: 250,
  rating: 5,
  reviewCount: 6,
  isTopShop: true,
  isInsider: true,
  description:
    "We exist to spread happiness. Whether it be creating imaginative and thoughtful products or connecting our passionate community of collectors, at Happy Everything! we are constantly seeking ways to spark enthusiasm to live a happy life. With an extensive product offering of happy items like interchangeable decor, maps, mugs, shaped ornaments, and serve ware, you can find a little happy in everything... {and we mean everything!}\n\nThe idea for Happy Everything! was born in 2003 when our Founding Artist & CEO, Laura Johnson, found herself inspired to create a product to make decorating for every holiday quick and easy. There was nothing quite like it existing in the market, so she created it herself: a versatile platter with removable seasonal attachments. And there it was... the original interchangeable concept was born. {Yep, we're the original!}\n\n*All new wholesale accounts are subject to approval.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:31.594Z",
    importedBy: "entity-db-cli",
  },
};
